import React from "react";

export const DownLine: React.FC<any> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <g>
      <g>
        <path
          d="M4.353555,5.546447095367432L8,9.192900095367431L11.64645,5.546447095367432C11.7402,5.4526785953674315,11.8674,5.400000083446532,12,5.400000083446532C12.1326,5.400000083446532,12.2598,5.4526785953674315,12.35355,5.546447095367432C12.4473,5.640215095367432,12.5,5.767392095367431,12.5,5.900000095367432C12.5,6.032610095367431,12.4473,6.159785095367432,12.35355,6.253555095367432L8.35356,10.253560095367432C8.158290000000001,10.448800095367432,7.84171,10.448800095367432,7.64644,10.253560095367432L3.646446,6.253555095367432C3.5526782,6.159785095367432,3.499999725819,6.032610095367431,3.499999725819,5.900000095367432C3.499999725819,5.767392095367431,3.5526782,5.640215095367432,3.646446,5.546446095367432C3.740215,5.452678495367431,3.867392,5.399999988079432,4,5.399999988079432C4.13261,5.399999988079432,4.259785,5.452678495367431,4.353555,5.546447095367432Z"
          fill="currentColor"
          fillOpacity="0.8799999952316284"
        />
      </g>
    </g>
  </svg>
);
